import AgentAssignedCases from './AgentAssignedCases'

export default AgentAssignedCases;